import React, { useContext, useMemo,useState,useCallback, useEffect } from 'react'
import { ThemeContext } from 'styled-components'
import { Pair } from '@pancakeswap-libs/sdk'
import { Button, CardBody, Flex, Text } from '@pancakeswap-libs/uikit'
import { Link } from 'react-router-dom'
import CardNav from 'components/CardNav'
import Question from 'components/QuestionHelper'
import FullPositionCard from 'components/PositionCard'
import { useUserHasLiquidityInAllTokens } from 'data/V1'
import { useTokenBalancesWithLoadingIndicator } from 'state/wallet/hooks'
import { StyledInternalLink, TYPE } from 'components/Shared'
import { LightCard } from 'components/Card'
import { RowBetween } from 'components/Row'
import { AutoColumn } from 'components/Column'
import {BigNumber as NewBigNumber} from 'bignumber.js'
import { useActiveWeb3React } from 'hooks'
import { usePairs } from 'data/Reserves'
import { toV2LiquidityToken, useTrackedTokenPairs } from 'state/user/hooks'
import { Dots } from 'components/swap/styleds'
import TranslatedText from 'components/TranslatedText'
import { TranslateString,useTranslation } from 'utils/translateTextHelpers'
import PageHeader from 'components/PageHeader'
import { useCompensateContract } from 'hooks/useContract'
import { utils } from 'ethers'
import { COMPENSATE_TOKEN } from 'constants/compensate'
import { withdraw_balance, get_withdraw_sign } from "API/compensate"
import { useTransactionAdder } from '../../state/transactions/hooks'
import TransactionConfirmationModal, { ConfirmationModalContent } from '../../components/TransactionConfirmationModal'
import { SpaceDiv,Title, DescriptionTitle,MiddleContext,RemainingDiv} from "./styleds"
import AppBody from '../AppBody'

const { body: Body } = TYPE

export default  function  Pool() {
  const theme = useContext(ThemeContext)
  const { account } = useActiveWeb3React()
  const [showConfirm, setShowConfirm] = useState<boolean>(false)
  const [attemptingTxn, setAttemptingTxn] = useState(false) // clicked confirm
  const [txHash, setTxHash] = useState<string>('')
  const [isShow, setIsShow] = useState(true) 

  const [exactAmount, setExactAmount] = useState<string>('0')
  const [remainingAmount,setRemainingAmount] = useState<string>('0')
  const [contractExtract,setContractExtract] = useState<string>('0')

  // fetch the user's balances of all tracked V2 LP tokens
  const trackedTokenPairs = useTrackedTokenPairs()
  
  // console.log('------------',trackedTokenPairs)
  const compensateContract = useCompensateContract()

  const addTransaction = useTransactionAdder()

  const tokenPairsWithLiquidityTokens = useMemo(
    () => trackedTokenPairs.map((tokens) => ({ liquidityToken: toV2LiquidityToken(tokens), tokens })),
    [trackedTokenPairs]
  )
  const liquidityTokens = useMemo(() => tokenPairsWithLiquidityTokens.map((tpwlt) => tpwlt.liquidityToken), [
    tokenPairsWithLiquidityTokens,
  ])
  const [v2PairsBalances, fetchingV2PairBalances] = useTokenBalancesWithLoadingIndicator(
    account ?? undefined,
    liquidityTokens
  )

  // fetch the reserves for all V2 pools in which the user has a balance
  const liquidityTokensWithBalances = useMemo(
    () =>
      tokenPairsWithLiquidityTokens.filter(({ liquidityToken }) =>
        v2PairsBalances[liquidityToken.address]?.greaterThan('0')
      ),
    [tokenPairsWithLiquidityTokens, v2PairsBalances]
  )



  const v2Pairs = usePairs(liquidityTokensWithBalances.map(({ tokens }) => tokens))
  const hasV1Liquidity = useUserHasLiquidityInAllTokens()
  
 

  const v2IsLoading = fetchingV2PairBalances || v2Pairs?.length < liquidityTokensWithBalances.length || v2Pairs?.some((V2Pair) => !V2Pair)

  const allV2PairsWithLiquidity = v2Pairs.map(([, pair]) => pair).filter((v2Pair): v2Pair is Pair => Boolean(v2Pair))



  const handleDismissConfirmation = useCallback(() => {
    setShowConfirm(false)
    setTxHash('')
  }, [ ])


  const withdrawalAllowance = ()=>{
    setShowConfirm(true)
    setAttemptingTxn(false)
  }
  
  /** state 10
  useEffect(() => {
    async function getData(){ 
       try{

       const res = await withdraw_balance({address:account}) 
       const {extractable,remaining} = res as any 
       setExactAmount(()=> parseFloat(Number(extractable).toFixed(6)).toString() )


        setRemainingAmount(()=> parseFloat(Number(remaining).toFixed(6)).toString())
        setIsShow(false)


        // if(compensateContract){          
        //   compensateContract.userCanExtract(account,amout.toString()).then(data=>{
        //     setContractExtract(data.toString())
        //   })
        // }


       }catch(e){
         setExactAmount(()=>'0')
         setRemainingAmount(()=>'0')
       }
        
    }
    getData()
  },[account,isShow,compensateContract])
  */


  const pendingText = `You will receive ${exactAmount} ${COMPENSATE_TOKEN}`

  async function onWithdrawalAllowance(){
    get_withdraw_sign({address:account}).then(data=>{
       const result  = data as any   
       const {compensate,timestamp,sign} = result
       const showCompensate = new NewBigNumber(compensate).div(new NewBigNumber(10).pow(18)).toString()
       if(compensateContract){
          setShowConfirm(true)
          setAttemptingTxn(true)
          compensateContract.withdraw(compensate,timestamp,sign,account).then(res=>{  
            setAttemptingTxn(false)
            addTransaction(res, {
              summary: `Extract ${exactAmount} WPSC`,
            })

            setTxHash(res.hash)
            res.wait().then((ires) => {
              setIsShow(true)
              setShowConfirm(false)
            })
          }).catch(e=>{
            setIsShow(true)
            setAttemptingTxn(false)
            setShowConfirm(false)
          })
        }
    })
    
    

  }

  function modalHeader() {
    return (
      <AutoColumn gap="md" style={{ marginTop: '20px' }}>
        <RowBetween align="flex-end">
            <Text>{exactAmount} {`${COMPENSATE_TOKEN}`}</Text>
        </RowBetween>

      </AutoColumn>
    )
  }

  function modalBottom() {
    return (
      <>
        <RowBetween>
         
        <Button onClick={async ()=>{ await onWithdrawalAllowance()}}>
          Confirm
        </Button>
        </RowBetween>
      </>
    )
  }

  const title1 = TranslateString(343,'Extractable')
  const title2 = TranslateString(344,'Remaining')
  const buttonText = TranslateString(339,'Extract')

  function ExtractSubsidy(){
     return (
      <>   
        {new  NewBigNumber(exactAmount).isGreaterThan(0) || new NewBigNumber(remainingAmount).isGreaterThan(0)?
            (<MiddleContext>
              <div>
                <div>
                   <Title>{title1}</Title>
                   <DescriptionTitle>{exactAmount} {`${COMPENSATE_TOKEN}`}</DescriptionTitle>
                </div>
                <RemainingDiv>
                  <Title>{title2}</Title>
                   <DescriptionTitle>{remainingAmount} {`${COMPENSATE_TOKEN}`}</DescriptionTitle>
                </RemainingDiv>
              </div>
              <div>
                  <Button id="join-pool-button" onClick={ ()=>{onWithdrawalAllowance()}} disabled={!new  NewBigNumber(exactAmount).isGreaterThan(0)}>
                  {buttonText} 
                </Button>
              </div>
            
           </MiddleContext>)
           :('')}
           
      </>
     )
  }

  return (
    <>
    
      <CardNav activeIndex={1} />
      <AppBody>

        <PageHeader title={TranslateString(74, 'Liquidity')} description={TranslateString(101, 'Add liquidity to receive LP tokens')}>
          <Button id="join-pool-button" as={Link} to="/add/ETH">
            {TranslateString(100,'Add Liquidity')}
          </Button>
          
          <ExtractSubsidy />
         
        </PageHeader>

   

        <AutoColumn gap="lg" justify="center">
          <CardBody>
            <AutoColumn gap="12px" style={{ width: '100%' }}>
              <RowBetween padding="0 8px">
                <Text color={theme.colors.text}>
                  <TranslatedText translationId={102}>Your Liquidity</TranslatedText>
                </Text>
                {/* <Question
                  text={TranslateString(
                    130,
                    'When you add liquidity, you are given pool tokens that represent your share. If you don’t see a pool you joined in this list, try importing a pool below.'
                  )}
                /> */}
              </RowBetween>

              {!account ? (
                <LightCard padding="40px">
                  <Body color={theme.colors.textDisabled} textAlign="center">                    
                    {TranslateString(103, 'Connect to a wallet to view your liquidity')}
                  </Body>
                </LightCard>
              ) : v2IsLoading ? (
                <LightCard padding="40px">
                  <Body color={theme.colors.textDisabled} textAlign="center">
                    <Dots>{TranslateString(104, 'Loading')}</Dots>
                  </Body>
                </LightCard>
              ) : allV2PairsWithLiquidity?.length > 0 ? (
                <>
                  {allV2PairsWithLiquidity.map((v2Pair) => (
                    <FullPositionCard key={v2Pair.liquidityToken.address} pair={v2Pair} />
                  ))}
                </>
              ) : (
                <LightCard padding="40px">
                  <Body color={theme.colors.textDisabled} textAlign="center">
                    <TranslatedText translationId={105}>No liquidity found.</TranslatedText>
                  </Body>
                </LightCard>
              )}

              <div>
                <Text fontSize="14px" style={{ padding: '.5rem 0 .5rem 0' }}>
                  {hasV1Liquidity
                    ? TranslateString(106, 'Uniswap V1 liquidity found!')
                    : TranslateString(107, "Don't see a pool you joined?")}{' '}
                  <StyledInternalLink id="import-pool-link" to={hasV1Liquidity ? '/migrate/v1' : '/find'}>
                    {hasV1Liquidity ? TranslateString(108, 'Migrate now.') : TranslateString(109, 'Import it.')}
                  </StyledInternalLink>
                </Text>
                <Text fontSize="14px" style={{ padding: '.5rem 0 .5rem 0' }}>
                  {TranslateString(110, 'Or, if you staked your LP tokens in a farm, unstake them to see them here.')}
                </Text>
              </div>
            </AutoColumn>
          </CardBody>
        </AutoColumn>
        <TransactionConfirmationModal
            isOpen={showConfirm}
            onDismiss={handleDismissConfirmation}
            attemptingTxn={attemptingTxn}
            hash={txHash || ''}
            content={() => (
              <ConfirmationModalContent
                title="You will receive"
                onDismiss={handleDismissConfirmation}
                topContent={modalHeader}
                bottomContent={modalBottom}
              />
            )}
            pendingText={pendingText}
          />
      </AppBody>
    </>
  )
}
